import { withAsyncLoading } from '../../../Components/Templates/AsyncPageLoading/withAsyncPageLoading';

const LoadableWorkerList = withAsyncLoading(async () =>
    import('./WorkerListPage').then((res) => res.WorkerListPage)
);

export { LoadableWorkerList };
